export function chooseText(path, mainObj, language = "de") {
  return mainObj[`${path}_${language}`]
}
